<!-- 患者查询 -->

<template>
  <Card :bordered="true" class="follow-visit" dis-hover v-if="showPage">
    <!-- HIS回访记录 -->
    <div slot="title">回访记录</div>
    <div class="patientSearch">
      <div class="select_table">
        <Table :columns="columns1" :data="tableData" :height="u_table_heigh">
          <template slot-scope="{ row, index }" slot="patientName"> </template>
        </Table>
        <Page
          v-if="tableData.length > 0"
          show-total
          show-sizer
          @on-change="getPatientHistoryList"
          :total="totalCount"
          :page-size="pageSize"
          @on-page-size-change="setPageSize"
          :current="pageIndex"
        ></Page>
      </div>
    </div>
  </Card>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import request from "@/utils/request";
import { isHasSystemPerm } from "@/directive/permission/index.js";
export default {
  props: {
    patientCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      activeItem: {},
      totalCount: 0,
      tableData: [],
      // 表格高度
      u_table_heigh: 300,
      pageIndex: 1,
      pageSize: 10, //一页10条
      columns1: [],
      consultationFlgList: [
        {
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 0,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["userInfo", "dicts"]),
    isHis() {
      return !isHasSystemPerm(["1000"]); // 没有百会系统就显示的是HIS回访记录
    },
    isBaihui() {
      return isHasSystemPerm(["1000:1027"]); //显示百会回复记录
    },
    // 2、回访记录：租户有百会的病案分析菜单权限，显示的是百会的回复记录；租户没有百会权限，显示的是HIS回访记录
    // true 百会回复记录 false HIS回访记录
    followVisitType() {
      return this.isBaihui ? true : false;
    },
    showPage() {
      return this.isHis || this.isBaihui;
    },
  },
  watch: {},
  methods: {
    ...mapActions([""]),
    setPageSize(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.getData();
    },
    getPatientHistoryList(page) {
      this.pageIndex = page;
      this.getData();
    },
    getData() {
      let obj = {
        pageIndex: this.pageIndex, //当前页
        pageSize: this.pageSize, //每页条数
        patientCode: this.patientCode, //患者编码
      };
      let url = this.followVisitType
        ? "/saasbaihui/patientHfRecordList"
        : "/saascashier/getPatientHFList";
      this.tableData = [];
      request.post(url, obj).then((res) => {
        if (this.followVisitType) {
          res.result.forEach((item) => {
            item.medicationEffect = this.common.valueToLabel(
              this.dicts.LOST_PATIENT_TYPE,
              item.medicationEffect
            );
            item.consultationFlg = this.common.valueToLabel(
              this.consultationFlgList,
              item.consultationFlg
            );
          });
        }
        this.tableData = res.result;
        this.totalCount = res.total;
      });
    },
    init() {
      this.columns1 = this.followVisitType
        ? [
            {
              title: "回访信息",
              key: "hfRemark",
              minWidth: 300,
            },
            {
              title: "服药效果",
              key: "medicationEffect",
              width: 120,
            },
            {
              title: "是否会诊",
              key: "consultationFlg",
              width: 120,
            },
            {
              title: "回访人",
              key: "taskHeadName",
              width: 120,
            },
            {
              title: "回访时间",
              key: "taskEndDateString",
              width: 170,
            },
          ]
        : [
            {
              title: "回访信息",
              key: "record",
              minWidth: 300,
            },
            {
              title: "记录时间",
              key: "crDt",
              width: 170,
            },
          ];
      this.getData();
    },
  },
  created() {
    if (!this.showPage) return;
    Promise.all([
      this.$store.dispatch("getWideUseList", "LOST_PATIENT_TYPE"),
    ]).then(() => {
      this.init();
    });
  },
  mounted: function () {},
};
</script>
<style scoped lang="scss">
</style>
